import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import token_red from './images/token-red.png'
import token_green from './images/token_nqtb.png'

const ModelsByCategory = ({
  modelsList,
  expandedModels,
  selectedModels,
  user,
  toggleExpand,
  handleAllCheckboxChange,
  handleCheckboxChange
}) => {
  // 1️⃣ Group models by category
  const groupedModels = modelsList.reduce((acc, model) => {
    const category = model.model_category || 'Uncategorized';
    if (!acc[category]) acc[category] = [];
    acc[category].push(model);
    return acc;
  }, {});

  return (
    <>
      {Object.entries(groupedModels).map(([category, models]) => (
        <div key={category} className="model-category-section">
          {/* CATEGORY HEADER */}
          <p className='hum-tox-p'>{category}</p>
          <div className='up-sel-mod'>
            {models.map((model) => {
              const allCellLines = Array.isArray(model.cell_line?.cell_line)
                ? model.cell_line.cell_line
                : [];
              const selectedForModel = selectedModels[model.id] || [];
              const allSelected =
                allCellLines.length > 0 &&
                allCellLines.every((cl) => selectedForModel.includes(cl));

              return (
                <div key={model.id} className="model-row">
                  {/* MODEL HEADER */}
                  <div 
    className="model-header" 
    onClick={() => toggleExpand(model.id)}
  >
    {/* Changed <button> to <span> to avoid nesting interactive elements */}
    <span className="chevron-btn">
      <FontAwesomeIcon
        icon={
          expandedModels.includes(model.id)
            ? faChevronUp
            : faChevronDown
        }
      />
    </span>
    <p className="mdl-name">{model.model_name}</p>
  </div>

                  {/* CELL LINE OPTIONS */}
                  {expandedModels.includes(model.id) && (
                    <div className="cell-line-list">
                      {/* All option */}
                      <div className="cell-line-row">
                        <label className="cell-line-item">
                          <input
                            className="inputs-cell-lines"
                            type="checkbox"
                            checked={allSelected}
                            onChange={() =>
                              handleAllCheckboxChange(model.id, allCellLines)
                            }
                          />
                          <span className="cell-line-label">All</span>
                        </label>
                      </div>

                      {allCellLines.map((cl, idx) => (
                        <div key={idx} className="cell-line-row">
                          <div>
                            <label className="cell-line-item">
                              <input
                                className="inputs-cell-lines"
                                type="checkbox"
                                checked={
                                  selectedModels[model.id]?.includes(cl) ||
                                  false
                                }
                                onChange={() =>
                                  handleCheckboxChange(model.id, cl)
                                }
                              />
                              <span className="cell-line-label">{cl}</span>
                            </label>
                          </div>

                          <div className="cost-div">
                            <p className="mdl-price-p">{model.model_price}</p>
                            <img
                              className="token-cost-sm"
                              src={
                                user && user.coins < model.model_price
                                  ? token_red
                                  : token_green
                              }
                              alt="token icon"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};

export default ModelsByCategory;
